var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:({ opacity: _vm.visible ? 1 : 0 }),attrs:{"data-testid":"CursorCrossHair"}},[_c('circle',{attrs:{"cx":_vm.x,"cy":_vm.y,"r":5}}),_c('line',{attrs:{"x1":_vm.x,"x2":_vm.x,"y1":0,"y2":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }